<div
  class="h-full w-full p-6 lg:p-10 flex flex-col overflow-y-auto custom-scrollbar bg-body-background relative"
>
  <header
    class="text-center mb-10 max-w-3xl mx-auto shrink-0 animate-fade-in-up"
  >
    <h1
      class="text-3xl lg:text-4xl font-extrabold text-heading tracking-tight mb-3"
    >
      {{ config.texts.templatesTitle }}
    </h1>
    <p class="text-secondary-text text-lg">
      {{ config.texts.templatesSubtitle }}
    </p>
  </header>

  <div
    class="w-full max-w-[1200px] mx-auto mb-8 shrink-0 animate-fade-in-up flex"
  >
    <nz-input-group
      [nzPrefix]="searchIcon"
      nzSize="large"
      class="w-full max-w-md mx-auto shadow-sm rounded-lg"
    >
      <input
        type="text"
        nz-input
        class="bg-input-background text-primary-text border-secondary-border focus:ring-focus-ring"
        [placeholder]="config.texts.searchPlaceholder"
        [ngModel]="searchQuery()"
        (ngModelChange)="onSearchChange($event)"
      />
    </nz-input-group>
    <ng-template #searchIcon
      ><i class="fas fa-search text-secondary-text"></i
    ></ng-template>
  </div>

  @if (isLoading()) {
    <div class="flex items-center justify-center p-12 flex-1">
      <i class="fas fa-circle-notch fa-spin text-4xl text-primary"></i>
    </div>
  } @else {
    @if (localTemplates().length === 0) {
      <div
        class="text-center p-12 bg-component-inner border border-primary-border rounded-xl w-full max-w-2xl mx-auto shrink-0 shadow-sm"
      >
        <i class="fad fa-folder-open text-5xl text-secondary-text mb-4"></i>
        <p class="text-primary-text font-medium">
          {{ config.texts.emptyState }}
        </p>
      </div>
    } @else {
      <div
        class="grid grid-cols-1 lg:grid-cols-2 gap-8 w-full max-w-[1200px] mx-auto pb-6 shrink-0"
      >
        @for (template of localTemplates(); track template.id) {
          <div
            class="flex flex-col bg-component-inner border border-primary-border rounded-xl shadow-sm hover:shadow-default hover:border-secondary-border transition-all duration-300 min-h-[320px] overflow-hidden group"
          >
            <div class="p-6 flex flex-col flex-1">
              <div class="flex items-start justify-between mb-4">
                <div
                  class="w-12 h-12 bg-alt-background border border-secondary-border rounded-lg flex items-center justify-center text-primary shadow-sm group-hover:scale-105 transition-transform shrink-0"
                >
                  <i class="fad fa-database text-xl"></i>
                </div>

                <div
                  nz-tooltip
                  [nzTooltipTitle]="'Unique Identifier: ' + template.key"
                  class="bg-alt-bold-background text-secondary-text border border-secondary-border px-3 py-1.5 rounded text-[10px] font-mono truncate max-w-xs shrink ml-4"
                >
                  {{ template.key }}
                </div>
              </div>

              <h3
                class="text-xl font-bold text-heading group-hover:text-primary transition-colors mb-2 line-clamp-1"
              >
                {{ template.name }}
              </h3>
              <p class="text-sm text-secondary-text line-clamp-3 mb-6 flex-1">
                {{ template.description || 'No description provided.' }}
              </p>

              <div class="flex flex-wrap gap-2 mb-6">
                @for (tag of template.tags | slice: 0 : 5; track tag) {
                  <nz-tag
                    class="!m-0 text-xs text-primary-text bg-section-background border-secondary-border"
                    >{{ tag }}</nz-tag
                  >
                }
                @if (template.tags && template.tags.length > 5) {
                  <nz-tag
                    class="!m-0 text-xs text-secondary-text bg-alt-background border-secondary-border"
                    >+{{ template.tags.length - 5 }}</nz-tag
                  >
                }
              </div>

              <button
                (click)="previewTemplate(template)"
                nz-button
                nzType="primary"
                class="w-full py-3 rounded-lg font-semibold bg-component-header group-hover:text-white! border border-secondary-border group-hover:bg-primary group-hover:text-primary-button-text group-hover:border-primary transition-all duration-300 shadow-sm"
              >
                {{ config.texts.previewBtn }}
              </button>
            </div>
          </div>
        }
      </div>

      @if (hasMoreTemplates()) {
        <div class="w-full flex justify-center mt-6 mb-12 shrink-0">
          <button
            (click)="fetchTemplates(false)"
            [disabled]="isPaginating()"
            class="px-8 py-3 bg-button-bg text-secondary-button-text border border-secondary-border rounded-lg font-medium hover:bg-hover-default transition-all shadow-sm disabled:opacity-50 flex items-center gap-2 cursor-pointer"
          >
            @if (isPaginating()) {
              <i class="fas fa-circle-notch fa-spin"></i>
            }
            {{ config.texts.loadMore }}
          </button>
        </div>
      }
    }
  }
</div>
